export const CRM_TYPES = ['Crm::Booking'];

export const defaulCrmType = 'Crm::Booking';
